module.exports = __webpack_public_path__ + "img/tw.3cceb462.svg";